<template>
  <section class="page-compare">
        <div class="page-compare shadow-10">
          <div id="page-comparar">
            <div class="all-products">
              <router-link to="/products"
                ><span class="access-direct-span">Ver todos los productos</span
                ><span class="icon icon-chevron-right"></span
              ></router-link>
            </div>
            <img
              v-if="iconBack"
              @click="goBack()"
              class="back"
              src="../../core/core-framework/assets/icons/arrow-left.svg"
            />
            <p class="page-comparar-title"></p>
            <div class="page-comparar-content">
              <p class="page-comparar-content-placeholder">
                Selecciona una opción
              </p>
              <div class="page-comparar-content-options-wrapper">
                <div class="page-comparar-content-options"></div>
              </div>
            </div>
          </div>
        </div>
  </section>
</template>

<script>

import { userService } from "../_services/user.service";
import dataDecisionTree from "./../_helpers/data/compare.json";

export default {
    
data() {
    return {
      user: {},
      users: [],
      dropdown: false,
      data: {},
      history: [],
      iconBack: false,
    };
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.users.loading = true;
    userService.getAll().then((users) => (this.users = users));
    this.getInfoDecisionTree();
  },
  methods: {
    getInfoDecisionTree() {
      this.data = Object.assign([], dataDecisionTree);
      setTimeout(() => {
        this.setDecisionTree();
      }, 300);
    },
    setDecisionTree(option) {
      const main = document.querySelector("#page-comparar");
      const optionsWrapper = main.querySelector(
        ".page-comparar-content-options-wrapper"
      );
      const options = main.querySelector(".page-comparar-content-options");
      main.classList.add("page-comparar-fade");
      if (option) {
        this.history.push(option);
        this.iconBack = true;
      }
      const data = this.getData();
      if (data.title === "¿Qué necesitas comparar?") this.iconBack = false;
      document.querySelector(".page-comparar-title").innerHTML = data.title;
      options.innerHTML = "";
      Object.keys(data.options).forEach((option) => {
        const opt = document.createElement("span");
        opt.innerHTML = option;
        if (typeof data.options[option] === "string") {
          const concat = (data.options[option].indexOf('?') < 0) ? '?' : '&';
          opt.onclick = function () {
            window.open(
              data.options[option] + concat +
                "utm_source=" + this.user.source + "&utm_medium=" +
                this.user.id_shop +
                "&utm_campaign=" +
                this.user.id_user,
              "_blank"
            );
          }.bind(this);
        } else {
          opt.onclick = function () {
            this.setDecisionTree(option);
          }.bind(this);
        }
        options.append(opt);
      });
      optionsWrapper.style.height = options.offsetHeight + "px";
      main.classList.remove("page-comparar-fade");
    },
    getData() {
      let newData = this.data;
      this.history.forEach((option) => (newData = newData.options[option]));
      return newData;
    },
    goBack() {
      this.history.pop();
      this.setDecisionTree();
    },
  },
}
</script>

<style lang="scss">

@import "../../core/core-framework/assets/scss/inc/mixins/_text_mixins.scss";
@import "../../core/core-framework/assets/scss/inc/_variables.scss";
@import "../../core/core-framework/assets/scss/inc/_bootstrap_custom_variables.scss";
@import "../../core/core-framework/assets/scss/inc/mixins/mixins";


.page-compare { background-color: $color-white; }
#page-comparar {
  .page-comparar {
    &-title {
      @include text(
        $size: 23px,
        $weight: 600,
        $color: $color-blue-02,
        $lineheight: 22px
      );
      margin-bottom: -58px;
      padding: 38px 60px;
      cursor: default;
    }
    &-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 16px;
      padding-bottom: 40px;
      min-height: calc(100vh - 260px);
      @media screen and (min-width: $screen-md) {
        min-height: 183px;
      }
      &-placeholder {
        @include text($size: 16px, $color: $color-grey-03, $lineheight: 18px);
        position: relative;
        padding: 8px 45px;
        cursor: default;
        &::after {
          @include position(
            $position: absolute,
            $height: 1px,
            $width: calc(100% + -97px),
            $bottom: 0,
            $right: 54px
          );
          content: "";
          background: $color-grey-04;
        }
      }
      &-options {
        display: flex;
        flex-wrap: wrap;
        margin-left: 35px;
        span {
          @include text(
            $size: 17px,
            $weight: 500,
            $color: $color-blue-02,
            $lineheight: 18px
          );
          margin: 6px;
          background: $color-blue-05;
          border-radius: 6px;
          padding: 16px 40px;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            background: $color-blue-02;
            color: $color-white;
          }
        }
        &-wrapper {
          overflow: hidden;
          opacity: 1;
          transition: opacity 0.4s, height 0.6s;
        }
      }
    }
  }
  &.page-comparar-fade {
    .page-comparar-content-options-wrapper {
      opacity: 0;
    }
  }
}
.all-products {
  a {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.2;
    color: $color-blue-04;
    float: right;
    position: relative;
    top: 33px;
    right: 27px;
    &:hover {
      text-decoration: none;
    }
  }
  .access-direct-span {
    text-decoration: underline;
  }
  .icon.icon-chevron-right {
    font-size: 20px;
    font-weight: 600;
    position: relative;
    top: 6px;
    left: 12px;
  }
}
.back {
  position: relative;
  top: 20px;
  left: 27px;
  cursor: pointer;
}
</style>